// utils/auth.js
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

export const getUserLevel = () => {
  try {
    const token = Cookies.get("access_token");

    if (token) {
      const decodedToken = jwtDecode(token);

      console.log("Decoded Token:", decodedToken);

      return {
        level: decodedToken.level,
        divisi: decodedToken.divisi || null,
        // id_wilayah dipakai halaman yang membatasi pilihan lokasi ke
        // penempatan akun (mis. Quality Control); 0 berarti belum ditempatkan.
        id_wilayah: decodedToken.id_wilayah || 0,
        nama_wilayah: decodedToken.nama_wilayah || null,
        id_user: decodedToken.id_user || null,
        id_divisi: decodedToken.id_divisi || null,
        // Akun mandor menunjuk ke master_mandor; 0/kosong berarti akun biasa.
        id_mandor: decodedToken.id_mandor || 0,
      };
    }

    return null;
  } catch (error) {
    console.error("Gagal men-decode token:", error);
    return null;
  }
};

// Akun mandor = JABATANNYA "Mandor".
//
// Tautan id_mandor sengaja BUKAN penentu: halaman Pembangunan Saya memakainya
// hanya untuk tahu mandor yang mana, sedangkan jenis akunnya ditentukan
// jabatan. Kalau tautan dijadikan penentu, akun berjabatan lain yang keliru
// tertaut ke data mandor akan terkunci hanya ke halaman mandor — termasuk
// kehilangan menu jabatannya sendiri (pernah terjadi pada akun Quality
// Kontrol). Aturan yang sama berlaku di backend (middlewares/access.go).
export const isAkunMandor = () => {
  const level = String(getUserLevel()?.level || "").trim();
  return level.toLowerCase() === "mandor";
};

// Akun yang datanya dibatasi ke wilayah penempatannya: pengawas lapangan dan
// Kacab (kepala cabang).
//
// "Kacab" memakai definisi yang sama dengan isKacab() di halaman Dashboard:
// Admin Cabang, atau Head dengan divisi Branch. Head divisi lain (Perencanaan,
// Keuangan, HRGA, Legalitas) dan Dirut adalah kantor pusat, jadi menangani
// semua wilayah. Aturan yang sama ditegakkan di backend (handler Quality
// Control) — kalau salah satu berubah, yang lain harus ikut.
export const isTerbatasWilayah = () => {
  const auth = getUserLevel();
  const level = String(auth?.level || "").trim();
  if (["Pengawas Cabang", "Quality Kontrol", "Admin Cabang"].includes(level)) return true;
  if (level === "Head") {
    return String(auth?.divisi || "").trim().toLowerCase() === "branch";
  }
  return false;
};
